// project imports
import Loadable from "uicomponent/Loadable";
import MinimalLayout from "layout/MinimalLayout";
import MainLayout from "layout/MainLayout";
import ErrorBoundary from "components/ErrorBoundary";

// login option 3 routing
const SignIn = Loadable(() => import("views/authentication/sign-in"));
const SignUp = Loadable(() => import("views/authentication/sign-up"));
const PasswordReminder = Loadable(() =>
  import("views/authentication/PasswordReminder")
);
const Insights = Loadable(() => import("views/insights"));
const Goodbye = Loadable(() => import("views/goodbye"));
const ConnectionSuccess = Loadable(() =>
  import("views/connection-success")
);

// Public invoice view
const PublicInvoiceView = Loadable(() => import("views/invoice"));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const UnauthenticatedRoutes = {
  path: "/",
  element: <MinimalLayout />,
  children: [
    {
      path: "/sign-in",
      element: <SignIn />,
    },
    {
      path: "/sign-up",
      element: <SignUp />,
    },
    {
      path: "/password-reminder",
      element: <PasswordReminder />,
    },
    {
      path: "/invoice/:id",
      element: <PublicInvoiceView />,
    },
    {
      path: "/goodbye",
      element: <Goodbye />,
    },
    {
      path: "/connection-success",
      element: <ConnectionSuccess />,
    },
    {
      element: <MainLayout />,
      children: [
        {
          path: "/insights",
          element: <Insights />,
        },
      ],
    },
    {
      path: "*",
      element: <ErrorBoundary />,
    },
  ],
};

export default UnauthenticatedRoutes;
